import styled from 'styled-components';

export const CardMiniatureContainerStyled = styled.div`
    width: 30em;
    height: 21em;
    border-radius: 2em;
    font-size: ${({ fontSize }) => fontSize};
    border: 2px solid ${({ color }) => color || ''};
    padding: 2em;
    display: flex;
    position: relative;
`;

export const CardMiniatureBackgroundStyled = styled.div`
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background-color: ${({ bgColor }) => bgColor};
    border-radius: 2em;
`;

export const CardMiniatureHeadStyled = styled.div`
    width: 9.5em;
    height: 13.5em;
    flex: 0 0 auto;
    svg {
        fill: ${({ headColor }) => headColor}; 
        width: 100%;
        height: 100%;
    }
    background-color: ${({ color }) => color};
    margin-right: 2em;
    border-radius: 1em;
`;

export const CardMiniatureInfoStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
`;

export const CardMiniatureInfoRowStyled = styled.div`
    border-radius: 0.5em;
    width: 100%;
    background-color: ${({ color }) => color};
`;
